<template>
	<div class="measurements-page">
		<!-- <template v-if="true"> -->
		<nav-bar name="Tus Medidas"></nav-bar>
		<template v-if="patient !== null && records.length > 0">
			<div class="has-text-left py-2 my-3 px-4">
				Ultimas medida:
				{{ formatRecordDateTime(lastMeasurementRecord.dateTime.toDate()) }}
			</div>
			<div class="menu-container nrg-flex-group px-4">
        <div
					id="measure-frecCard"
					class="menu-measure nrg-flex-item"
					@click="onActionClick"
				>
					<div class="title is-2 is-txt-white">
						<health-icon size="40px" class="inline-icon"></health-icon>
						{{ lastMeasurementRecord.frecCard || '-' }}
					</div>
					<span class="is-size-5">Frecuencia Cardiaca</span>
				</div>
				<div
					id="measure-sat02"
					class="menu-measure nrg-flex-item"
					@click="onActionClick"
				>
					<div class="title is-2 is-txt-white">
						<percentage-icon size="40px" class="inline-icon"></percentage-icon>
						{{ formatDecimalValue(lastMeasurementRecord.satO2) || '-' }}
					</div>
					<span></span>
					<span class="is-size-5">Saturación de Oxígeno</span>
				</div>
				<div
					id="measure-frecresp"
					class="menu-measure nrg-flex-item"
					@click="onActionClick"
				>
					<div class="title is-2 is-txt-white">
						<lung-icon size="40px" class="inline-icon"></lung-icon>
						{{ formatDecimalValue(lastMeasurementRecord.frecResp) || '-' }}
					</div>
					<span class="is-size-5">Frecuencia Respiratoria</span>
				</div>
				<div
					id="measure-temp"
					class="menu-measure nrg-flex-item"
					@click="onActionClick"
				>
					<div class="title is-2 is-txt-white">
						<thermometer-icon size="40px" class="inline-icon"></thermometer-icon>
						{{ lastMeasurementRecord.temp || '-' }}
					</div>
					<span class="is-size-5">Temperatura</span>
				</div>
				
			</div>

			<div id="more-results" class="historicalresults px-4 mt-5">
				<div
					class="tiny-results-display py-2 my-2 cell-shiny-accent"
					v-for="(resultItem, i) in records"
					:key="'extra-record' + i"
				>
					<div
						class="label-date py-2"
						@click="indexShouldBeOpen = indexShouldBeOpen === i ? -1 : i"
					>
						{{ formatRecordDateTime(resultItem.dateTime.toDate()) }}
					</div>
					<div v-if="indexShouldBeOpen === i" class="nrg-flex-group py-3">
						<div class="item-measure">
							<span>Frec. Card:</span>
							{{ formatDecimalValue(resultItem.frecCard) || '-' }}
						</div>
						<div class="item-measure">
							<span>Sat O2: </span>
							{{ formatDecimalValue(resultItem.satO2) || '-' }}
						</div>
						<div class="item-measure">
							<span>Frec. Resp.:</span>
							{{ formatDecimalValue(resultItem.frecResp) || '-' }}
						</div>
						<div class="item-measure">
							<span>Temp.:</span>
							{{ formatDecimalValue(resultItem.temp) || '-' }}
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="container p-2">
				<div class="notification is-warning">
					Aún no tenemos tus signos vitales registrados.
				</div>

				<div class="results-container"></div>
			</div>
		</template>
	</div>
</template>

<script lang="ts">
	import NavBar from "@/components/NavBar.vue";
	import { computed, defineComponent, ref, watchEffect } from "vue";
	import useUser from "@/store/UserState";
	import usePatientHelper from "@/store/PatientHelperState";
	import { Patient } from "@/domain/entities/Patient";
	import { onBeforeRouteLeave } from "vue-router";
	import { DateTime } from "luxon";
	import HealthIcon from "@/assets/HealthIcon.vue";
	import LungIcon from "@/assets/LungIcon.vue";
	import ThermometerIcon from "@/assets/ThermometerIcon.vue";
	/* import ThermometerFilledIcon from "@/assets/ThermometerFilledIcon.vue"; */
	import PercentageIcon from "@/assets/PercentageIcon.vue";

	function onActionClick(ev: Event): object[] {
		console.log("actionClick", ev);
		return [];
	}

	function formatRecordDateTime(datetime: Date): string {
		return DateTime.fromJSDate(datetime).toFormat("hh:mm a - dd/MM/yy");
	}

	function formatDecimalValue(value: number): number {
    return Math.ceil(value * 100) / 100; 
	}

	export default defineComponent({
		name: "Measurements",

		components: {
			NavBar,
      LungIcon,
      ThermometerIcon,
      /* ThermometerFilledIcon, */
      PercentageIcon,
      HealthIcon,
		},

		setup() {
			const { user: patient, onUserDataChange, closeUserDataChange } = useUser();
			const { listenMeasurements, measurements } = usePatientHelper();

			onUserDataChange();
			onBeforeRouteLeave(() => {
				closeUserDataChange();
			});

			let lastMeasurementRecord = computed<MeasurementRecord | undefined>(
				() => (patient.value as Patient)?.lastMeasurementRecord
			);

			// let records = watchSensorValuesFromPatient((patient as Patient).id)
			// patient.value
			watchEffect(() => {
				console.log('patient still found');
				if (patient.value != null) {
					console.log('patient found', (patient.value).id);
					listenMeasurements((patient.value).id)
				}
			});

			let indexShouldBeOpen = ref<number>(-1);
			return {
				indexShouldBeOpen,
				// latest,
				// historical,
				patient,
				onActionClick,
				lastMeasurementRecord: lastMeasurementRecord,
				records: measurements,
				formatRecordDateTime,
        formatDecimalValue,
			};
		},

		typpingOnSearch(): object[] {
			return [];
		},
	});
</script>

<style lang="stylus" scoped>
	@import '../styles/layout.styl';
	@import '../styles/elements.styl';

	.menu-measure {
		@extend .cell-shiny-primary;
	}

	div.nrg-flex-item {
		min-height: 150px;
	}

	div.nrg-flex-item.half-height {
		min-height: 75px;
	}

	.tiny-results-display {
		// background: skyblue;
		// border: 1px solid blue;
		border-radius: 4px;
		display: block;
	}
	.inline-icon {
		display: inline-block;
		vertical-align: middle;		
	}
</style>
